import React, { 
    useState, 
    // useRef, 
    useEffect, 
    useContext, 
    useRef
} from 'react';
import DOMPurify from 'dompurify';

import Init from '../../../../Init/Init';
import UtilityFunction from '../../../../Util/Util';

import './ProductContent.scss';
import CustomToast from '../../../Utilities/Toast/Toast';
import PrimaryButton from '../../../Utilities/PrimaryButton/PrimaryButton';
import SecondaryButton from '../../../Utilities/SecondaryButton/SecondaryButton';

import NavigationContext from '../../../../Context/NavigationContext';

import { connect } from 'react-redux';
import shoppingCartActions from '../../../../Redux/Shopping/shopping-action';

import useAnalyticsEventTracker from '../../../../GoogleAnalytics/useAnalyticsEventTracker';
import CheckoutBox from '../CheckoutBox/CheckoutBox';
import { Row } from 'react-bootstrap';
import FormInput from '../../../Utilities/FormInput/FormInput';

const GaTracker = ({
    action,
    label
}) => {
    const gaEventCategory = 'Product Detail';

    const gaEventTracker = useAnalyticsEventTracker(gaEventCategory);

    gaEventTracker(action, label);
};

const { numberFormatting } = UtilityFunction;
const { addToCart, saveDesignAttachment } = shoppingCartActions;

const AddonList = (props) => {
    const [selectedAddon, setSelectedAddon] = useState(null);
    const existingAddon = props.addonList;

    const selectAddon = (addonId) => {
        props.selectAddon(addonId);
    }

    useEffect( () => {
        setSelectedAddon(props.selected);
    }, [ props.selected ]);
    
    return (
        existingAddon &&
        existingAddon.length > 0 ? (
            existingAddon.map( (item, index) => {
                return (
                    <div 
                        key={index} 
                        onClick={() => selectAddon(item.id)} 
                        className={
                            `
                            product-attr-item 
                            ${selectedAddon === item.id ? 'active' : ''}
                            `
                        }>
                        { item.addon_name }
                    </div>
                )
            })
        ) : ''
    );
}

const ProductContent = (props) => {
    /**
     * Initiate variables
     */
    const { FontAwesomeIcon, config } = Init;
    const { addToCart, selectVariant } = props;

    const [ customerCode, setCustomerCode ] = useState(null);
    const [ selectedVariant, setSelectedVariant ] = useState(null);
    const [ selectedAddon, setSelectedAddon ] = useState(0);
    const [ selectedStraw, setSelectedStraw ] = useState(0);
    const [ quantity, setQuantity ] = useState(config.orderRule.moq);
    const [ useMultiColor, setUseMultiColor ] = useState(0);

    const designAttachmentRef = useRef(props.attachment);
    const transactionNotesRef = useRef(null);

    // Notes components
    const cupSidesRef = useRef({value: ""});
    const printedColorsRef = useRef({value: ""});
    const designDescRef = useRef({value: ""});
    
    const { allowTransaction } = config;
    const { productDetail } = props;
    
    const navigation = useContext(NavigationContext);
    const { navigate } = navigation;

    useEffect( () => {
        if(props.identity !== undefined && props.identity.hasOwnProperty('customer_code')) {
            setCustomerCode(props.identity.customer_code);
        }
    }, [props.identity]);

    useEffect( () => {
        // setSelectedVariant(null);
        setQuantity(props.productDetail.product.moq);
    }, [props.productDetail]);

    useEffect( () => {
        setQuantity(config.orderRule.moq);
        if( selectedVariant !== null ) {
            selectVariant(productDetail.variants[selectedVariant].id);
        }
    }, [selectedVariant]);

    useEffect( () => {

    }, [props.addons]);

    useEffect( () => {
        if( props.transactionNotes && props.transactionNotes !== "" ) {
            const partedTrxNotes = props.transactionNotes.split(";;");
    
            if( cupSidesRef ) {
                cupSidesRef.current.value = partedTrxNotes[0].split(";")[1];
            }
    
            if( printedColorsRef ) {
                printedColorsRef.current.value = partedTrxNotes[1].split(";")[1];
            }
    
            if( designDescRef ) {
                designDescRef.current.value = partedTrxNotes[2].split(";")[1];
            }
        }
    }, [props.transactionNotes]);

    const selectSize = (sizeId) => {
        let sizeName = productDetail.variants.hasOwnProperty(sizeId) ? productDetail.variants[sizeId].size_name : '';
        let outOfStock = productDetail.variants.hasOwnProperty(sizeId) && productDetail.variants[sizeId].quantity <= 0;

        GaTracker({
            action: `Choose Size`,
            label: `Product ${productDetail.variant_name}. Chosen Size: ${sizeName}. In stock: ${ outOfStock ? 'No' : 'Yes' }`
        });

        if( !outOfStock ) {
            setSelectedVariant(sizeId);
        }

    }

    const selectAddon = (addonId) => {
        setSelectedAddon(addonId);
    }

    const selectStraw = (strawId) => {
        setSelectedStraw(strawId);
    }

    const changeCounter = (counter) => {
        GaTracker({
            action: `Change Quantity`,
            label: `Product ${productDetail.variant_name}. Updated Qty: ${productDetail.variants[selectedVariant].quantity}`
        });

        setQuantity(counter);
    }

    const addCartItem = () => {
        if(quantity > 0) {
            const cartItem = {
                productId: productDetail.product.id,
                sizeId: parseInt(productDetail.variants[selectedVariant].size_id),
                addons: selectedAddon !== null ? selectedAddon : 0,
                straw: selectedStraw !== null ? selectedStraw : 0,
                quantity,
                isReadyStock: productDetail.product.is_ready_stock,
                useMultiColor
            };

            const ownerCode = customerCode !== null ? customerCode : 'guest';
            const photoPath = productDetail.product.product_image !== null ? `${productDetail.product.product_image}` : '';
            const chosenPrice = productDetail.variants[selectedVariant].discount_price > 0 ? productDetail.variants[selectedVariant].discount_price : productDetail.variants[selectedVariant].price;
            
            const isDesignUploaded = props.attachment !== null;

            if( productDetail.product.is_ready_stock > 0 || ( productDetail.product.is_ready_stock === 0 && isDesignUploaded )  ) {
                if( cupSidesRef.current && printedColorsRef.current && designDescRef.current ) {
                    if( cupSidesRef?.current?.value !== "" || designDescRef?.current?.value !== "" ) {
                        transactionNotesRef.current = {
                            value: `Sisi Cup: ;${ cupSidesRef?.current?.value ?? "" } ;;Warna yang dicetak: ;${ printedColorsRef?.current?.value ?? "" } ;;Keterangan Desain: ;${ designDescRef?.current?.value ?? "" }`
                        }
                    }
                }


                addToCart(ownerCode, cartItem, transactionNotesRef?.current?.value ?? props.transactionNotes);
                
                // GaTracker({
                //     action: `Add To Cart`,
                //     label: `Add product ${productDetail.variant_name} size ${productDetail.variants[selectedVariant].size_name} ${productDetail.variants[selectedVariant].quantity}x`
                // });
    
                
                setToastContent({
                    title: 'Added to cart!',
                    content: {
                        title: productDetail.product.product_name,
                        variant: `${productDetail.variants[selectedVariant].size_name} ${ selectedAddon ? `+ ${renderAddonName()}` : "" } ${ selectedStraw ? `+ ${renderStrawName()}` : "" }`,
                        price: numberFormatting((chosenPrice * quantity) + getAddonPrice() + getStrawPrice())
                    },
                    status: 1,
                    show: true,
                    image: photoPath
                });
            } else {
                setToastContent({
                    title: "Design must be uploaded!",
                        content: {
                            title: productDetail.product.product_name,
                            variant: `${productDetail.variants[selectedVariant].size_name} ${ selectedAddon ? `+ ${renderAddonName()}` : "" }`,
                            price: numberFormatting((chosenPrice * quantity) + getAddonPrice())
                        },
                        status: 0,
                        show: true,
                        image: photoPath
                });
            }
        } else {
            //
        }

    }

    // Add On
    const renderAddonImage = () => {
        for( let index in props.addons ) {
            let item = props.addons[index];

            if( item.id === selectedAddon ) return item.addon_image;
        }

        return "";
    }

    const renderAddonName = () => {
        for( let index in props.addons ) {
            let item = props.addons[index];

            if( item.id === selectedAddon ) return item.addon_name;
        }

        return "";
    }

    const getAddonPrice = () => {
        for( let index in props.addons ) {
            let item = props.addons[index];

            if( item.id === selectedAddon ) return quantity * parseInt(item.price);
        }

        return 0;
    }
    
    // Straws
    const renderStrawImage = () => {
        for( let index in props.straws ) {
            let item = props.straws[index];

            if( item.id === selectedStraw ) return item.image_path;
        }

        return "";
    }

    const renderStrawName = () => {
        for( let index in props.straws ) {
            let item = props.straws[index];

            if( item.id === selectedStraw ) return item.straw_name;
        }

        return "";
    }

    const getStrawPrice = () => {
        for( let index in props.straws ) {
            let item = props.straws[index];

            if( item.id === selectedStraw ) return quantity * parseInt(item.straw_price);
        }

        return 0;
    }
    
    // const renderAttachment = () => {
    //     return ``;
    // }

    const updateAttachment = async (file) => {
        designAttachmentRef.current = file;
        await props.saveAttachment(file);
    }

    // Toast
    const [toastContent, setToastContent] = useState({
        title: '',
        content: {
            title: '',
            variant: '',
            price: ''
        },
        status: null,
        show: false
    });

    const closeToast = () => {
        setToastContent({
            title: '',
            content: {
                title: '',
                variant: '',
                price: ''
            },
            status: null,
            show: false
        });
    };

    const navigateToCart = () => {
        if( !config.requireLogin || (config.requireLogin && props.identity.hasOwnProperty('id')) ) {
            navigate('/cart');
        } else {
            // navigate('/login');
            window.location.href = "/login";
        }
    };

    return (
        <>
            <CustomToast show={toastContent.show} 
                    onClose={closeToast} 
                    title={toastContent.title}  
                    status={toastContent.status}
                    customClass='add-to-cart-toast'
            >
                <div className="cart-item-image">
                    <img src={toastContent.image} alt="" />
                </div>
                <div className="cart-item-content">
                    <div className="cart-item-first-row">
                        <div className="title">
                            { toastContent.content.title }
                        </div>
                        <div className="size">
                            { toastContent.content.variant }
                        </div>
                    </div>
                    <div className="cart-item-second-row">
                        <div className="price">
                            { toastContent.content.price }
                        </div>
                    </div>
                </div>
                <div className="cart-item-button-container">
                    <SecondaryButton size="sm" customClass="btn-close-toast" onClick={() => closeToast()}>
                        Tutup
                    </SecondaryButton>
                    {
                        toastContent.status ? (
                            <PrimaryButton size="sm" customClass="btn-check-cart" onClick={() => navigateToCart()}>
                                Cek Keranjang <FontAwesomeIcon icon={['fas', 'arrow-right']} />
                            </PrimaryButton>
                        ) : ""
                    }
                </div>
            </CustomToast>

            <div className="product-content">
                {/* 
                    1. Product Name
                    2. Brand / Category
                    3. Price
                    -----------------------------
                    4. Size List
                    -----------------------------
                    5. Buy Quantity
                    -----------------------------
                    6. Button "Add To Cart"
                */}
                <div className="product-content-header">
                    <h1 className='product-name'>
                        { productDetail.product.product_name }
                    </h1>
                    <h3 className='order-term'>
                        *Min. order mulai dari <span className='highlighted'>{ productDetail.product.moq } pcs</span>
                    </h3>
                    {/* <span className="product-category-name">
                        { productDetail.product_category_name } / { productDetail.product_name }
                    </span> */}
                    <div className="product-description" dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(productDetail.product.description)}}>
                    </div>
                    {
                        productDetail.variants.hasOwnProperty(selectedVariant) ? (
                            productDetail.variants[selectedVariant].hasOwnProperty('discount_price') && productDetail.variants[selectedVariant].discount_price > 0 ?
                            (
                                <>
                                    <span className="product-price discounted">
                                        { numberFormatting(productDetail.variants[selectedVariant].price) }
                                    </span>
                                    <span className="product-price">
                                        { numberFormatting(productDetail.variants[selectedVariant].discount_price) }
                                    </span>
                                </>
                            ) : (
                                <span className="product-price">
                                    { numberFormatting(productDetail.variants[selectedVariant].price) }
                                </span>
                            )
                        ) : (
                            // <span className="product-price">
                            //     Choose Size
                            // </span>
                            ""
                        )
                    }
                </div>
                <div className="product-attr-list-container">
                    <div className="product-attr-list">
                        {
                            Object.keys(productDetail.variants).length > 0 ? (
                                Object.keys(productDetail.variants).map( (item, index) => {
                                    let value = productDetail.variants[item];

                                    return (
                                        <div 
                                            key={index} 
                                            onClick={() => selectSize(item)} 
                                            className={
                                                `
                                                product-attr-item 
                                                ${selectedVariant === item ? 'active' : ''} 
                                                ${ value.quantity ? '' : 'disabled' }
                                                `
                                            }>
                                            { value.size_name }
                                        </div>
                                    )
                                } )
                            ) : ''
                        }
                    </div>
                </div>
                {
                    selectedVariant && (props.addons.length > 0 || productDetail.variants[selectedVariant].product_addons.length > 0) ? (
                        <>
                            <div className="product-attr-list-container">
                                <h3 className="product-attr-list-title">
                                    { productDetail.product.is_package ? `Add ons:` : `Add ons for:` }
                                </h3>
                                {
                                    selectedAddon ? (
                                        <img className='product-attr-image' src={renderAddonImage()} alt="" />
                                    ) : ""
                                }
                                <div className="product-attr-list">
                                    <AddonList 
                                        selected={selectedAddon}
                                        addonList={ props.addons.filter( (value) => {
                                            return (productDetail.variants[selectedVariant].product_addons).includes(value.id.toString());
                                        } ) }
                                        selectAddon={ (value) => selectAddon(value) }
                                    />
                                </div>
                            </div>
                            {
                                productDetail.product.straws !== null && productDetail.product.straws.length > 0 ? (
                                    <div className="product-attr-list-container">
                                        <h3 className="product-attr-list-title">
                                            Straws
                                        </h3>
                                        {
                                            selectedStraw ? (
                                                <img className='product-attr-image' src={renderStrawImage()} alt="" />
                                            ) : ""
                                        }
                                        <div className="product-attr-list">
                                            <AddonList 
                                                selected={selectedStraw}
                                                addonList={ props.straws.filter( (value) => {
                                                    return (productDetail.product.straws).includes(value.id.toString());
                                                } ) }
                                                selectAddon={ (value) => selectStraw(value) }
                                            />
                                        </div>
                                    </div>
                                ) : ""
                            }
                            {
                                productDetail.product.is_ready_stock > 0 ? "" : (
                                    <>
                                        <div className="product-attr-list-container">
                                            <h3 className="product-attr-list-title">
                                                Upload your design:
                                            </h3>
                                            {/* {
                                                designAttachmentRef.current ? (
                                                    <img className='product-attr-image' src={renderAttachment()} alt="" />
                                                ) : ""
                                            } */}
                                            <div className="product-attr-list limitless">
                                                <Row className={`custom-design-form`}>
                                                    <FormInput  
                                                        attribute={{
                                                            label: "",
                                                            ref: designAttachmentRef,
                                                            value: props.attachment,
                                                            width: 12,
                                                            type: "file",
                                                            required: false,
                                                            allowedFileTypes: ['PDF', 'PSD'],
                                                            maxFileSize: 100 // MB
                                                        }}
                                                        options={[]}
                                                        name={"design_attachment"} 
                                                        onChange={ async (name, value) => await updateAttachment(value) } 
                                                        customClass={`custom-design-form-input`}
                                                    />
                                                </Row>
                                            </div>
                                        </div>
                                        <div className="product-attr-list-container">
                                            <h3 className="product-attr-list-title">
                                                Pilih Jumlah Warna:
                                            </h3>
                                            <div className="product-attr-list">
                                                <div  
                                                    onClick={() => setUseMultiColor(() => {   
                                                        return 0;
                                                    })} 
                                                    className={
                                                        `
                                                        product-attr-item 
                                                        ${useMultiColor === 0 ? 'active' : ''}
                                                        `
                                                    }>
                                                        Sablon 1 Warna
                                                </div>
                                                {/* <div  
                                                    onClick={() => setUseMultiColor(() => {   
                                                        return 1;
                                                    })} 
                                                    className={
                                                        `
                                                        product-attr-item 
                                                        ${useMultiColor === 1 ? 'active' : ''}
                                                        `
                                                    }>
                                                        2 - 4 Warna
                                                </div> */}
                                            </div>
                                        </div>
                                        <div className="product-attr-list-container">
                                            <h3 className="product-attr-list-title">
                                                Sisi Design:
                                            </h3>
                                            <div className="product-attr-list">
                                                <FormInput  
                                                    attribute={{
                                                        label: "",
                                                        ref: cupSidesRef,
                                                        value: cupSidesRef?.current?.value,
                                                        width: 10,
                                                        type: "text",
                                                        required: true,
                                                        placeholder: "Contoh: 1 sisi, 3 sisi, atau keliling"
                                                    }}
                                                    name={"cupSides"} 
                                                    // onChange={ async (name, value) => await updateTransactionNotes(value) } 
                                                    customClass={`transaction-notes`}
                                                />
                                            </div>
                                            <div className="product-attr-list-notes">
                                                <span className="notes-item">
                                                    *Brapa sisi desain di cup, misal 1 sisi, 3 sisi, keliling
                                                </span>
                                            </div>
                                        </div>
                                        <div className="product-attr-list-container">
                                            <h3 className="product-attr-list-title">
                                                Warna yang dicetak:
                                            </h3>
                                            <div className="product-attr-list">
                                                <FormInput  
                                                    attribute={{
                                                        label: "",
                                                        ref: printedColorsRef,
                                                        value: printedColorsRef?.current?.value,
                                                        width: 10,
                                                        type: "text",
                                                        required: true,
                                                        placeholder: "Contoh: Hijau, Kuning, Hitam"
                                                    }}
                                                    name={"printedColors"} 
                                                    // onChange={ async (name, value) => await updateTransactionNotes(value) } 
                                                    customClass={`transaction-notes`}
                                                />
                                            </div>
                                            <div className="product-attr-list-notes">
                                                <span className="notes-item">
                                                    *Wajib lampirkan warna contoh di file
                                                </span>
                                            </div>
                                        </div>
                                        <div className="product-attr-list-container">
                                            <h3 className="product-attr-list-title">
                                                Keterangan Desain:
                                            </h3>
                                            <ul className="product-attr-list-notes">
                                                <li className="notes-item">
                                                    Tinta emas dan blok warna ada tambahan biaya karena penebalan design (bayar manual terpisah).
                                                </li>
                                                <li className="notes-item">
                                                    Tidak bisa ganti ukuran cup, design, warna & ukuran. Tolong dipastikan kembali sebelum di-upload dan pastikan design kualitas HD (tidak pecah).
                                                </li>
                                                <li className="notes-item">
                                                    Pengerjaan Test print dan naik cetak massal 7 hari kerja setelah acc design
                                                </li>
                                                <li className="notes-item">
                                                    Pesanan yang sudah dibuat bisa di lacak dengan memilih menu 'Lacak Pesanan' di pojok kanan atas halaman website ini. 
                                                </li>
                                                <li className="notes-item">
                                                    Pengerjaan Cek design & atur posisi design H+5(maks) (akan dihubungi oleh team design)
                                                </li>
                                            </ul>
                                            <div className="product-attr-list">
                                                <FormInput  
                                                    attribute={{
                                                        label: "",
                                                        ref: designDescRef,
                                                        value: designDescRef?.current?.value,
                                                        width: 10,
                                                        type: "textarea",
                                                        required: true,
                                                        placeholder: ""
                                                    }}
                                                    name={"designDesc"} 
                                                    // onChange={ async (name, value) => await updateTransactionNotes(value) } 
                                                    customClass={`transaction-notes`}
                                                />
                                            </div>
                                            <div className="product-attr-list-notes">
                                                <span className="notes-item">
                                                    *Posisi desain, ukuran, perubahan, dll
                                                </span>
                                            </div>
                                        </div>
                                    </>
                                )
                            }
                        </>
                    ) : ''
                }
            </div>
            {
                allowTransaction && selectedVariant && useMultiColor !== null ? (
                    <CheckoutBox 
                        productImage={ productDetail.variants[selectedVariant].variant_image }
                        productName={ productDetail.product.product_name }
                        variantName={ productDetail.variants[selectedVariant].size_name }
                        changeCounter={ (counter) => changeCounter(counter) }
                        moq={ productDetail.product.moq }
                        directToWa={ productDetail.product.direct_to_wa }
                        selectedVariant={ selectedVariant }
                        quantity={ quantity }
                        totalPrice={ (quantity * productDetail.variants[selectedVariant].discount_price) + getAddonPrice() + getStrawPrice() }
                        addToCartDisabled={ !selectedVariant || !quantity }
                        addToCart={ () => addCartItem() }
                        addon={ renderAddonName() }
                        straw={ renderStrawName() }
                        useMultiColor={ useMultiColor }
                    />
                ) : ""
            }
        </>
    );
}

const mapStateToProps = (state) => {
    return {
        identity: state.auth.identity,
        addons: state.addons.addonsList,
        straws: state.addons.strawsList,
        attachment: state.shop.designAttachment,
        transactionNotes: state.shop.transactionNotes
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        addToCart: (ownerCode, cartItem, transactionNotes) => dispatch(addToCart(ownerCode, cartItem, transactionNotes)),
        saveAttachment: async ( file ) => dispatch(await saveDesignAttachment(file)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductContent);